import { Injectable } from '@angular/core';
import { StorageKeys } from '../app.constants';
import { AnomalieGardiennageEvent } from '../entities/user-events/anomalie-gardiennage.event';
import { AnomalieInterPonctuelleEvent } from '../entities/user-events/anomalie-inter-ponctuelle.event';
import { AnomalieInterventionEvent } from '../entities/user-events/anomalie-intervention.event';
import { AnomalieRondeEvent } from '../entities/user-events/anomalie-ronde.event';
import { AnomalieZoneEvent } from '../entities/user-events/anomalie-zone.event';
import { ArriveeSurSiteEvent } from '../entities/user-events/arrivee-sur-site.event';
import { CompteRenduEvent } from '../entities/user-events/compte-rendu.event';
import { DebutVacationGardiennageEvent } from '../entities/user-events/debut-vacation-gardiennage.event';
import { DebutVacationInterPonctuelle } from '../entities/user-events/debut-vacation-inter-ponctuelle.event';
import { DebutVacationInterventionEvent } from '../entities/user-events/debut-vacation-intervention.event';
import { DebutVacationTourneeEvent } from '../entities/user-events/debut-vacation-tournee.event';
import { DeclarationPositionRondeEvent } from '../entities/user-events/declaration-position-ronde.event';
import { DeclarationPositionEvent } from '../entities/user-events/declaration-position.event';
import { FinVacationGardiennageEvent } from '../entities/user-events/fin-vacation-gardiennage.event';
import { FinVacationInterPonctuelleEvent } from '../entities/user-events/fin-vacation-inter-ponctuelle.event';
import { FinVacationInterventionEvent } from '../entities/user-events/fin-vacation-intervention.event';
import { FinVacationTourneeEvent } from '../entities/user-events/fin-vacation-tournee.event';
import { InfoRondeEvent } from '../entities/user-events/info-ronde.event';
import { InfoVacationEvent } from '../entities/user-events/info-vacation.event';
import { MarqueNotifLueEvent } from '../entities/user-events/marque-notif-lue.event';
import { MarqueNotifsLuesEvent } from '../entities/user-events/marque-notifs-lues.event';
import { PointageAnomalieEvent } from '../entities/user-events/pointage-anomalie.event';
import { PointageRondeEvent } from '../entities/user-events/pointage-ronde.event';
import { PointageEvent } from '../entities/user-events/pointage.event';
import { SuppressionPassageRondeEvent } from '../entities/user-events/suppression-passage-ronde.event';
import { UserEvent } from '../entities/user-events/user-event.model';
import { InvalidUserEventException } from '../shared/exceptions/invalid-user-event.exception';
import { StorageService } from './storage.service';
import { ClotureCompteRenduPreliminaireEvent } from '../entities/user-events/finish-vacation-inter-ponctuelle.event';
import { AppelClientEvent } from '../entities/user-events/appel-client.event';
import { SetContactReponseEvent } from '../entities/user-events/set-contact-reponse.event';
import { AnomalieRondePonctuelleEvent } from '../entities/user-events/anomalie-ronde-ponctuelle.event';
import { InfoRondePonctuelleEvent } from '../entities/user-events/info-ronde-ponctuelle.event';
import { PointageRondePonctuelleEvent } from '../entities/user-events/pointage-ronde-ponctuelle.event';
import { AgentVaAppelerClientPourAccesSiteEvent } from '../entities/user-events/agent-va-appeler-client.event';

/**
 * Stocke les évènements utilisateurs en interne.
 * Ne pas utiliser cette classe nativement mais le UserEventWriteService, qui utilise cette classe comme tampon local
 */
@Injectable({ providedIn: 'root' })
export class UserEventLocalService {
  constructor(private readonly storage: StorageService) {}

  private static hydrate(obj: any): UserEvent {
    switch (obj.type) {
      case DebutVacationGardiennageEvent.NAME:
        return DebutVacationGardiennageEvent.hydrate(obj);
      case DebutVacationTourneeEvent.NAME:
        return DebutVacationTourneeEvent.hydrate(obj);
      case ArriveeSurSiteEvent.NAME:
        return ArriveeSurSiteEvent.hydrate(obj);
      case DebutVacationInterventionEvent.NAME:
        return DebutVacationInterventionEvent.hydrate(obj);
      case DebutVacationInterPonctuelle.NAME:
        return DebutVacationInterPonctuelle.hydrate(obj);
      case FinVacationGardiennageEvent.NAME:
        return FinVacationGardiennageEvent.hydrate(obj);
      case FinVacationTourneeEvent.NAME:
        return FinVacationTourneeEvent.hydrate(obj);
      case FinVacationInterventionEvent.NAME:
        return FinVacationInterventionEvent.hydrate(obj);
      case FinVacationInterPonctuelleEvent.NAME:
        return FinVacationInterPonctuelleEvent.hydrate(obj);
      case MarqueNotifLueEvent.NAME:
        return MarqueNotifLueEvent.hydrate(obj);
      case MarqueNotifsLuesEvent.NAME:
        return MarqueNotifsLuesEvent.hydrate(obj);
      case AnomalieGardiennageEvent.NAME:
        return AnomalieGardiennageEvent.hydrate(obj);
      case AnomalieInterventionEvent.NAME:
        return AnomalieInterventionEvent.hydrate(obj);
      case AnomalieInterPonctuelleEvent.NAME:
        return AnomalieInterPonctuelleEvent.hydrate(obj);
      case AnomalieRondeEvent.NAME:
        return AnomalieRondeEvent.hydrate(obj);
      case AnomalieRondePonctuelleEvent.NAME:
        return AnomalieRondePonctuelleEvent.hydrate(obj);
      case AnomalieZoneEvent.NAME:
        return AnomalieZoneEvent.hydrate(obj);
      case InfoVacationEvent.NAME:
        return InfoVacationEvent.hydrate(obj);
      case InfoRondeEvent.NAME:
        return InfoRondeEvent.hydrate(obj);
      case InfoRondePonctuelleEvent.NAME:
        return InfoRondePonctuelleEvent.hydrate(obj);
      case DeclarationPositionEvent.NAME:
        return DeclarationPositionEvent.hydrate(obj);
      case DeclarationPositionRondeEvent.NAME:
        return DeclarationPositionRondeEvent.hydrate(obj);
      case PointageRondeEvent.NAME:
        return PointageRondeEvent.hydrate(obj);
      case PointageRondePonctuelleEvent.NAME:
        return PointageRondePonctuelleEvent.hydrate(obj);
      case SuppressionPassageRondeEvent.NAME:
        return SuppressionPassageRondeEvent.hydrate(obj);
      case PointageEvent.NAME:
        return PointageEvent.hydrate(obj);
      case PointageAnomalieEvent.NAME:
        return PointageAnomalieEvent.hydrate(obj);
      case CompteRenduEvent.NAME:
        return CompteRenduEvent.hydrate(obj);
      case ClotureCompteRenduPreliminaireEvent.NAME:
        return ClotureCompteRenduPreliminaireEvent.hydrate(obj);
      case AppelClientEvent.NAME:
        return AppelClientEvent.hydrate(obj);
      case AgentVaAppelerClientPourAccesSiteEvent.NAME:
        return AgentVaAppelerClientPourAccesSiteEvent.hydrate(obj);
      case SetContactReponseEvent.NAME:
        return SetContactReponseEvent.hydrate(obj);
      default:
        throw new InvalidUserEventException(
          `User event de type ${obj.type} non reconnu, il ne sera pas envoyé. Il faut l'ajouter dans user-event.local.service.ts`
        );
    }
  }

  public add(evt: UserEvent): Promise<any> {
    return this.extract()
      .then(evts => {
        evts.push(evt);
        return evts;
      })
      .then(evts => this.saveAll(evts));
  }

  public saveAll(evts: UserEvent[]): Promise<void> {
    return this.storage.set(StorageKeys.USER_EVENTS, JSON.stringify(evts));
  }

  public extract(): Promise<UserEvent[]> {
    return this.storage.get(StorageKeys.USER_EVENTS).then(json => {
      if (!json) {
        return [];
      }
      return (
        JSON.parse(json)
          ?.filter((x: any) => !!x)
          .map(UserEventLocalService.hydrate) ?? []
      );
    });
  }
}
